import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation, Trans } from 'react-i18next';

import { Flex, Image, Text } from 'Components/Base';

const ReviewContent = ({ imageUrl, title, description }) => {
  const { t } = useTranslation('classroom');
  return (
    <Flex flexDirection={'column'} alignItems={'center'}>
      <Image src={imageUrl} />
      <Text textStyle={'heading2'} as="h4" fontWeight={'medium'} textAlign={'center'} mt={9}>
        <Trans components={[<br key="title" />]}>{title}</Trans>
      </Text>
      <Text as="p" color={'greyscale.grey3'} textAlign={'center'}>
        <Trans components={[<br key="paragraph" />]}> {description}</Trans>
      </Text>
    </Flex>
  );
};

ReviewContent.propTypes = {
  imageUrl: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
};

ReviewContent.defaultProps = {
  imageUrl: 'https://assets.skooldio.com/classroom/course_review.svg',
};

export default ReviewContent;
